import React, { useState, useEffect } from "react";
import getCondominio from "../../../../API/server/getCondominios";
import updateCondominio from "../../../../API/Manager/responsaveisUser";
import "../../../../styles/desktop/responsaveis.css";

export default function Responsaveis({ onBack }) {
    const [showBackButton, setShowBackButton] = useState(false);
    const [showConfirmation, setShowConfirmation] = useState(false);
    const [isSaving, setIsSaving] = useState(false);

    const initialFormState = {
        email: false,
        whatsapp: false,
        telefone: false,
    };

    const initialValues = {
        sindico: { nome: "", email: "", whatsapp: "", telefone: "" },
        administrador: { nome: "", email: "", whatsapp: "", telefone: "" },
        construtora: { nome: "", email: "", whatsapp: "", telefone: "" },
        fornecedor: { nome: "", email: "", whatsapp: "", telefone: "" },
    };

    const [formStates, setFormStates] = useState({
        sindico: { ...initialFormState },
        administrador: { ...initialFormState },
        construtora: { ...initialFormState },
        fornecedor: { ...initialFormState },
    });

    const [formValues, setFormValues] = useState(initialValues);

    useEffect(() => {
        const timer = setTimeout(() => {
            setShowBackButton(true);
        }, 500);

        return () => clearTimeout(timer);
    }, []);

    useEffect(() => {
        async function loadCondominioData() {
            try {
                const data = await getCondominio(); 
                console.log(data.condominio)
                if (data && data.condominio) {
                    const cond = data.condominio;

                    const updateResponsavel = (contatoObj, responsavelObj) => {
                        const contato = contatoObj || {};
                        const responsavel = responsavelObj || {};
                        return {
                            states: {
                                email: !!contato.email,
                                whatsapp: !!contato.whatsapp,
                                telefone: !!contato.telefone,
                            },
                            values: {
                                nome: responsavel.nome || "",
                                email: contato.email || "",
                                whatsapp: contato.whatsapp || "",
                                telefone: contato.telefone || "",
                            },
                        };
                    };

                    const sindicoData = updateResponsavel(cond.sindico?.contato, cond.sindico?.responsavel);
                    const administradorData = updateResponsavel(cond.administrador?.contato, cond.administrador?.responsavel);
                    const construtoraData = updateResponsavel(cond.construtora?.contato, cond.construtora?.responsavel);
                    const fornecedoraData = updateResponsavel(cond.fornecedor?.contato, cond.fornecedor?.responsavel);

                    setFormStates({
                        sindico: sindicoData.states,
                        administrador: administradorData.states,
                        construtora: construtoraData.states,
                        fornecedor: fornecedoraData.states,
                    });

                    setFormValues({
                        sindico: sindicoData.values,
                        administrador: administradorData.values,
                        construtora: construtoraData.values,
                        fornecedor: fornecedoraData.values,
                    });
                }
            } catch (error) {
                console.error("Erro ao carregar dados do condomínio:", error);
            }
        }

        loadCondominioData();
    }, []);

    const handleBackButtonClick = () => {
        setShowBackButton(false);
        setTimeout(() => onBack(), 300);
    };

    const handleSaveChanges = () => {
        setShowConfirmation(true);
    };

    const handleCheckboxChange = (form, field) => {
        setFormStates((prevState) => ({
            ...prevState,
            [form]: {
                ...prevState[form],
                [field]: !prevState[form][field],
            },
        }));
    };

    const handleInputChange = (form, field, value) => {
        setFormValues((prevState) => ({
            ...prevState,
            [form]: {
                ...prevState[form],
                [field]: value,
            },
        }));
    };

    // Função para formatar o payload no formato esperado pela API
    const formatPayload = (values) => {
        return {
            sindico: {
                contato: {
                    email: values.sindico.email,
                    whatsapp: values.sindico.whatsapp,
                    telefone: values.sindico.telefone
                },
                responsavel: {
                    nome: values.sindico.nome,
                    cargo: "Síndico"
                }
            },
            administrador: {
                contato: {
                    email: values.administrador.email,
                    whatsapp: values.administrador.whatsapp,
                    telefone: values.administrador.telefone
                },
                responsavel: {
                    nome: values.administrador.nome,
                    cargo: "Administrador"
                }
            },
            construtora: {
                contato: {
                    email: values.construtora.email,
                    whatsapp: values.construtora.whatsapp,
                    telefone: values.construtora.telefone
                },
                responsavel: {
                    nome: values.construtora.nome,
                    cargo: "Representante"
                }
            },
            fornecedor: {
                contato: {
                    email: values.fornecedor.email,
                    whatsapp: values.fornecedor.whatsapp,
                    telefone: values.fornecedor.telefone
                },
                responsavel: {
                    nome: values.fornecedor.nome,
                    cargo: "Fornecedor"
                }
            }
        };
    };

    const confirmSaveChanges = async () => {
        setIsSaving(true);

        try {
            const payload = formatPayload(formValues);
            await updateCondominio(payload);
            alert("Dados do condomínio atualizados com sucesso!");
        } catch (error) {
            console.error("Erro ao atualizar condomínio:", error);
            alert("Erro ao atualizar condomínio. Tente novamente.");
        } finally {
            setIsSaving(false);
            setShowConfirmation(false);
        }
    };

    const renderForm = (label, formKey) => (
        <div className="form-section">
            <h3>{label}</h3>
            <div className="form-group">
                <label><b>Nome do Responsável:</b></label>
                <input
                    placeholder="Nome do responsável"
                    value={formValues[formKey].nome}
                    onChange={(e) => handleInputChange(formKey, "nome", e.target.value)}
                />
            </div>
            <div className="form-group">
                <label>
                    <input
                        type="checkbox"
                        checked={formStates[formKey].email}
                        onChange={() => handleCheckboxChange(formKey, "email")}
                    />
                    Notificação E-mail
                </label>
                <input
                    type="email"
                    placeholder="E-mail"
                    disabled={!formStates[formKey].email}
                    style={{
                        backgroundColor: formStates[formKey].email ? "white" : "#e0e0e0",
                    }}
                    value={formValues[formKey].email}
                    onChange={(e) => handleInputChange(formKey, "email", e.target.value)}
                />
            </div>
            <div className="form-group">
                <label>
                    <input
                        type="checkbox"
                        checked={formStates[formKey].whatsapp}
                        onChange={() => handleCheckboxChange(formKey, "whatsapp")}
                    />
                    Notificação WhatsApp
                </label>
                <input
                    placeholder="WhatsApp"
                    disabled={!formStates[formKey].whatsapp}
                    style={{
                        backgroundColor: formStates[formKey].whatsapp ? "white" : "#e0e0e0",
                    }}
                    value={formValues[formKey].whatsapp}
                    onChange={(e) => handleInputChange(formKey, "whatsapp", e.target.value)}
                />
            </div>
            <div className="form-group">
                <label>
                    <input
                        type="checkbox"
                        checked={formStates[formKey].telefone}
                        onChange={() => handleCheckboxChange(formKey, "telefone")}
                    />
                    Notificação Número de Telefone
                </label>
                <input
                    placeholder="Telefone"
                    disabled={!formStates[formKey].telefone}
                    style={{
                        backgroundColor: formStates[formKey].telefone ? "white" : "#e0e0e0",
                    }}
                    value={formValues[formKey].telefone}
                    onChange={(e) => handleInputChange(formKey, "telefone", e.target.value)}
                />
            </div>
        </div>
    );

    return (
        <div className="responsaveisContent">
            <div className="responsaveis-body">
                <div className="form-row">
                    {renderForm("Síndico", "sindico")}
                    {renderForm("Administrador", "administrador")}
                </div>
                <div className="form-row">
                    {renderForm("Construtora", "construtora")}
                    {renderForm("Fornecedor", "fornecedor")}
                </div>
                <div className="responsaveis-submit-button" onClick={handleSaveChanges}>
                    Salvar Alterações
                </div>
            </div>
            {showBackButton && (
                <div
                    className="responsaveis-back-button fade-in"
                    onClick={handleBackButtonClick}
                >
                    Voltar
                </div>
            )}
            {showConfirmation && (
                <div className="confirmation-popup">
                    <p>Tem certeza que deseja salvar as alterações?</p>
                    <div className="popup-buttons">
                        <button onClick={confirmSaveChanges} disabled={isSaving}>
                            {isSaving ? "Salvando..." : "Sim"}
                        </button>
                        <button onClick={() => setShowConfirmation(false)} disabled={isSaving}>
                            Não
                        </button>
                    </div>
                </div>
            )}
        </div>
    );
}
